/**
 * RESPONSIBILITY: the About page's opening statement — when the church began, and who it is.
 *
 * One band, framed in the same patterned border as the welcome on the home page, so the
 * two statements of who the church is read as belonging together.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, List } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { LetterRow } from './rows/letter';

@Section({ name: SectionName.AboutEstablished, label: 'About · Established' })
export class AboutEstablishedSection {
  @Text({ label: 'Title', maxLength: 300, default: 'Established in 2001' })
  heading!: string;

  @Paragraph({
    label: 'Welcome', maxLength: 4000, rows: 5,
    description: 'The paragraph under the title.',
  })
  intro!: string;

  @Text({ label: 'Second title', maxLength: 300, group: 'Who we are', collapsed: true })
  whoHeading!: string;

  @Paragraph({ label: 'Who we are', maxLength: 4000, rows: 5, group: 'Who we are' })
  whoBody!: string;

  @List({
    label: 'The letters', of: () => LetterRow, maxItems: 8, group: 'Who we are',
    description: 'Each letter of the name and what it stands for, in order. Leave empty to leave them off.',
  })
  letters!: LetterRow[];
}
